export default class Navbar {
    static init(): void {
        this.handleMobileToggle();
        this.handleDesktopToggle();
        this.handleScroll();
        this.desktopSubmenu();
        this.desktopSubmenuMobile();
        this.handleCheckBodyClass();
        this.navbarLogoAnimationClass();
        this.setActiveMenuItem();
        this.changeUrlRefresh();
    }

    static handleMobileToggle(): void {
        const navbar = document.querySelector('.navbar');
        if (!navbar) return;

        navbar.querySelectorAll('.navbar__mobile-toggle').forEach((toggler) => {
            toggler.addEventListener('click', () => {
                navbar.classList.toggle('navbar--mobile-show');

                const submenuDesktop = document.querySelectorAll('.js-nav-item-submenu-mobile.is-open');

                if (submenuDesktop.length > 0) {
                    submenuDesktop.forEach((item) => {
                        item.classList.remove('is-open');
                    });
                }
            });
        });

        const links = navbar.querySelectorAll('.navbar-mobile .nav-link');
        links.forEach((link) => {
            link.addEventListener('click', () => {
                if (!link.classList.contains('nav-link--has-submenu')) {
                    navbar.classList.remove('navbar--mobile-show');
                }
            });
        });
    }

    static handleDesktopToggle(): void {
        const navbar = document.querySelector('.navbar');
        navbar?.querySelectorAll('.navbar__desktop-toggle').forEach((toggler) => {
            toggler.addEventListener('click', () => {
                navbar.classList.toggle('navbar--desktop-show');
            });
        });
    }

    static handleScroll(): void {
        const navbar = document.querySelector('.navbar');
        const body = document.querySelector('body') as HTMLBodyElement;

        window.addEventListener('scroll', () => {
            if (window.scrollY > 0 || body.classList.contains('navbar-static')) {
                navbar?.classList.add('navbar--scrolled');
                navbar?.classList.remove('navbar--scrolled--light');
            } else {
                navbar?.classList.remove('navbar--scrolled');
                navbar?.classList.remove('navbar--scrolled--light');
            }
        });
    }

    static desktopSubmenu(): void {
        const navbar = document.querySelector('.navbar');
        if (!navbar) return;
        
        let isMouseOverItem = false;
        let activeMenuItem: Element | null = null;
        
        document.querySelectorAll('.navbar [data-menu]').forEach(item => {
            item.addEventListener('mouseenter', function(event) {
                const target = event.currentTarget as Element;
                if (activeMenuItem !== target) {
                    resetActiveState(false); // Nezavírejte vše při přechodu mezi položkami
                    activateItemAndSubmenu(target);
                    activeMenuItem = target;
                }
                isMouseOverItem = true;
            });
        });
        
        document.querySelectorAll('.navbar [data-submenu]').forEach(submenu => {
            submenu.addEventListener('mouseenter', () => {
                isMouseOverItem = true; // Udržuje submenu otevřené, když je myš nad ním
            });
            submenu.addEventListener('mouseleave', () => {
                isMouseOverItem = false;
                setTimeout(() => {
                    if (!isMouseOverItem) resetActiveState(true); // Zavřete submenu pouze pokud uživatel opustil submenu a není nad žádnou položkou
                }, 250);
            });
        });
        
        document.querySelectorAll('.navbar .nav-item--not-submenu, .navbar-desktop__menu-top').forEach(item => {
            item.addEventListener('mouseenter', () => {
                resetActiveState(true); // Okamžitě resetujte a zavřete vše při přechodu na položku bez submenu
            });
        });
        
        function resetActiveState(closeAll: boolean) {
            if (closeAll) {
                deactivateAll();
            }
            if (activeMenuItem) {
                deactivateSubmenu(activeMenuItem);
                activeMenuItem = null;
            }
        }
        
        function activateItemAndSubmenu(currentItem: Element) {
            const menuId = currentItem.getAttribute('data-menu');
            currentItem.classList.add('is-active');
            if (menuId) {
                const submenu = document.querySelector(`.navbar [data-submenu="${menuId}"]`) as HTMLElement;
                if (submenu) {
                    submenu.style.display = 'block';
                    requestAnimationFrame(() => {
                        submenu.classList.add('navbar-fade-in');
                        submenu.classList.remove('navbar-fade-out');
                    });
                }
            }
        }

        function deactivateSubmenu(currentItem: Element) {
            currentItem.classList.remove('is-active');
            const menuId = currentItem.getAttribute('data-menu');
            if (menuId) {
                const submenu = document.querySelector(`.navbar [data-submenu="${menuId}"]`) as HTMLElement;
                if (submenu) {
                    submenu.classList.add('navbar-fade-out');
                    submenu.classList.remove('navbar-fade-in');
                    setTimeout(() => {
                        submenu.style.display = 'none';
                    }, 250);
                }
            }
        }

        function deactivateAll() {
            document.querySelectorAll('.navbar [data-menu], .navbar [data-submenu]').forEach(item => {
                item.classList.remove('is-active');
                if (item.getAttribute('data-submenu')) {
                    (item as HTMLElement).style.display = 'none';
                    item.classList.add('navbar-fade-out');
                    item.classList.remove('navbar-fade-in');
                }
            });
        }
    }

    static desktopSubmenuMobile(): void {
        const submenuDesktop = document.querySelectorAll('.js-nav-item-submenu-mobile');

        if (submenuDesktop.length > 0) {
            submenuDesktop.forEach((item) => {
                if (!item.classList.contains('nav-item--mobile-link')) {
                    item.addEventListener('click', () => {
                        item.classList.toggle('is-open');
                    });
                }
                else {
                    const linkArrow = item.querySelector('.nav-link__icon');
                    if (linkArrow) {
                        linkArrow.addEventListener('click', () => {
                            item.classList.toggle('is-open');
                        });
                    }
                }
            });
        }
    }

    static handleCheckBodyClass(): void {
        const body = document.querySelector('body') as HTMLBodyElement;
        const navbar = document.querySelector('.navbar');

        if (body.classList.contains('navbar-static')) {
            navbar?.classList.add('navbar--scrolled');
        }
    }

    static navbarLogoAnimationClass(): void {
        let currentContent = 0;

        function toggleContent() {
            const contents = document.querySelectorAll('.js-navbar-content');

            // Skrytí všech obsahů a odstranění všech animačních tříd
            contents.forEach((content) => {
                content.classList.remove('fade-in', 'fade-out');
                (content as HTMLElement).style.opacity = '0'; // Zajištění, že jsou všechny prvky neviditelné
            });

            // Příprava aktuálního obsahu k zobrazení
            const currentElement = contents[currentContent] as HTMLElement;
            currentElement.style.opacity = '1'; // Nastavení viditelnosti pro animaci
            currentElement.classList.add('fade-in'); // Aplikace fade-in efektu

            // Aktualizace indexu pro další obsah
            currentContent = (currentContent + 1) % contents.length;
        }

        // Inicializace prvního obsahu před nastavením intervalu
        toggleContent();

        // Nastavení intervalu pro automatickou změnu každých 5 sekund
        setInterval(toggleContent, 5000);

    }

    static setActiveMenuItem() {
        const menuLinks = document.querySelectorAll('.nav-submenu-item__list li a');
        menuLinks.forEach((content) => {
            const currentUrl = window.location.pathname + window.location.hash;
            // console.log(currentUrl);
            if (currentUrl == content.getAttribute('href')) {
                content.classList.add('active');
            }
        });
    }

    static changeUrlRefresh() {
        document.querySelectorAll('.nav-submenu-item__list a').forEach((item: Element) => {
            item.addEventListener('click', (e: Event) => {
                const target = e.target as HTMLAnchorElement;
                e.preventDefault();
                if (location.href !== target.href) {
                    window.history.pushState({}, '', target.href);
                    location.reload();
                }
            });
        });        
    }
}
